export const SIP_PROVIDER_LABELS = {
  CREATE_PROVIDER: 'Add SIP Provider',
  EDIT_PROVIDER: 'Edit SIP Provider',
  PROVIDER_NAME: 'Name',
  DESCRIPTION: 'Description',
  URL: 'URL',
  PORT: 'Port',
  PROTOCOL: 'Protocol',
  USERNAME: 'Username',
  PASSWORD: 'Password',
  ACTIONS: 'Actions',
  SEARCH_PROVIDERS: 'Search providers...',
  NO_PROVIDERS: 'There are no SIP providers yet.',
} as const;

export const SIP_PROVIDER_VALIDATION = {
  NAME_MIN_LENGTH: 1,
  NAME_MAX_LENGTH: 120,
  DESCRIPTION_MAX_LENGTH: 250,
  URL_MAX_LENGTH: 255,
  USERNAME_MAX_LENGTH: 120,
  PASSWORD_MAX_LENGTH: 120,
  PROTOCOL_MAX_LENGTH: 20,
} as const;
